import React from 'react';
import UnderConstruction from '../../../../components/UnderConstruction';
import SharedHeader from '../../../../components/SharedHeader';
import DashboardFooter from '../../../../components/DashboardFooter';

const OnCreateBoard = () => {
  return (
    <>
      <SharedHeader />
      <UnderConstruction pageName="User Creation Management" />
      <DashboardFooter />
    </>
  );
};

export default OnCreateBoard;
